import {NgModule} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';

import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {MatInputModule} from '@angular/material/input';
import {MAT_FORM_FIELD_DEFAULT_OPTIONS, MatFormFieldModule} from "@angular/material/form-field";
import {HttpClientModule} from "@angular/common/http";
import {AuthInterceptorProviders} from './core/interceptors/auth.interceptor';
import {PdfViewerModule} from "ng2-pdf-viewer";
import {MatButtonModule} from "@angular/material/button";
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import {MatNativeDateModule} from "@angular/material/core";
import {MatCheckboxModule} from "@angular/material/checkbox";
import {MatDialogModule} from "@angular/material/dialog";
import {MatCardModule} from "@angular/material/card";
import {MatDatepickerModule} from "@angular/material/datepicker";
import {MatSelectModule} from "@angular/material/select";
import {MatExpansionModule} from "@angular/material/expansion";
import {NgxDropzoneModule} from "ngx-dropzone";
import {MatIconModule} from "@angular/material/icon";
import {MAT_SNACK_BAR_DEFAULT_OPTIONS, MatSnackBarModule} from "@angular/material/snack-bar";
import {MatProgressSpinnerModule} from "@angular/material/progress-spinner";
import {MainToolbarComponent} from "./core/components/main-toolbar/main-toolbar.component";
import {FooterComponent} from "./core/components/footer/footer.component";
import {SharedModule} from "./shared/shared.module";
import {MatListModule} from "@angular/material/list";
import {InvalidLinkComponent} from './invalid-link/invalid-link.component';
import { InstallerComponent } from './installer/installer.component';
import { InstallBidComponent } from './installer/install-bid/install-bid.component';
import { InstallBidsComponent } from './installer/install-bids/install-bids.component';
import {MatTooltipModule} from "@angular/material/tooltip";
import { InstallQuestionComponent } from './installer/install-question/install-question.component';
import { InstallAskQuestionDialogComponent } from './installer/install-ask-question-dialog/install-ask-question-dialog.component';
import {MatButtonToggleModule} from "@angular/material/button-toggle";
import {MatSlideToggleModule} from "@angular/material/slide-toggle";
import {MatTabsModule} from '@angular/material/tabs';
import { InstallCompanyComponent } from './installer/install-company/install-company.component';
import {MatRadioModule} from '@angular/material/radio';


@NgModule({
  declarations: [
    AppComponent,
    AppComponent,
    MainToolbarComponent,
    FooterComponent,
    InvalidLinkComponent,
    InstallerComponent,
    InstallBidComponent,
    InstallBidsComponent,
    InstallQuestionComponent,
    InstallAskQuestionDialogComponent,
    InstallCompanyComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    MatInputModule,
    MatFormFieldModule,
    HttpClientModule,
    PdfViewerModule,
    MatButtonModule,
    BrowserAnimationsModule,
    MatNativeDateModule,
    MatCheckboxModule,
    ReactiveFormsModule,
    MatDialogModule,
    MatCardModule,
    MatDatepickerModule,
    MatSelectModule,
    MatExpansionModule,
    NgxDropzoneModule,
    MatIconModule,
    MatSnackBarModule,
    MatProgressSpinnerModule,
    SharedModule,
    MatListModule,
    MatTooltipModule,
    MatButtonToggleModule,
    MatSlideToggleModule,
    MatTabsModule,
    MatRadioModule,
  ],
  providers: [
    AuthInterceptorProviders,
    { provide: MAT_FORM_FIELD_DEFAULT_OPTIONS, useValue: { appearance: 'outline' } },
    {
      provide: MAT_SNACK_BAR_DEFAULT_OPTIONS,
      useValue: {duration: 2500}
    },
    AuthInterceptorProviders
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
}
